<div *ngFor="let Library of AllLibraries" class="Content-title-Task">
  <div class="title-components">
    <h1>Plantillas {{ Library.Title }}</h1>
  </div>

  <div class="Content-Tasks">
    <div *ngFor="let Library_Task of Library.Library" class="Card-Task">
      <div class="Content-Card">
        <div class="Card-Notification">
          <div class="notifications button-square">
            <i class="fas fa-book-open"></i>
          </div>
        </div>
        <div class="Body-Card">
          <div class="Title-Card">
            <h2>{{ Library_Task.Library }}</h2>
          </div>
          <div class="Subtitle-Card">
            {{ GetGreeting() }}, {{ NameUser() }},
            {{ Library_Task.Description }}
          </div>
        </div>
      </div>
      <div class="Btn-See-Task">
        <a
          routerLink="{{ Library_Task.RouteLink }}"
          class="Btn-Task btn-icon-text-left"
        >
          <span class="text">Ver plantillas</span
          ><i class="fa-solid fa-list-check"></i>
        </a>
      </div>
    </div>

    <div *ngIf="Library.Library.length <= 3"></div>
  </div>
</div>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
